import { ApdmReportMetrics } from '@euler/model/apdm';

/** Customers a message went out to, whether or not it arrived. */
export function apdmFunnelAttempted(metrics: ApdmReportMetrics): number {
  return metrics.reached + metrics.unconfirmed + metrics.unreachable;
}

export interface ApdmFunnelStep {
  label: string;
  count: number;
  /** Steps past booking are the campaign's results, not its reach. */
  outcome: boolean;
}

/**
 * The campaign funnel, each step a subset of the one before: a lead that
 * booked or converted also counts as interested, one that converted also
 * as booked. A greeting offers nothing, so it stops at replies.
 */
export function apdmFunnelSteps(
  metrics: ApdmReportMetrics,
  options: { greeting?: boolean; redeemed?: boolean } = {},
): ApdmFunnelStep[] {
  const reach: ApdmFunnelStep[] = [
    { label: '已触达', count: metrics.reached, outcome: false },
    { label: '回复', count: metrics.replied, outcome: false },
  ];
  if (options.greeting) return reach;
  const converted = metrics.converted;
  const booked = metrics.booked + converted;
  const engaged = metrics.engaged + booked + metrics.lost;
  return [
    ...reach,
    { label: '有意向', count: engaged, outcome: false },
    { label: '已预约', count: booked, outcome: true },
    { label: '已转化', count: converted, outcome: true },
    ...(options.redeemed
      ? [{ label: '券已核销', count: metrics.redeemed, outcome: true }]
      : []),
  ];
}

/** A share as the pages print it, e.g. `20.1%`; `—` with nothing to share. */
export function apdmPercent(part: number, whole: number, digits = 1): string {
  if (!whole) return '—';
  return `${((part / whole) * 100).toFixed(digits)}%`;
}
